<template>
  <div class="mobile-detail mobile" v-if="!loading" id="view">
    <el-backtop></el-backtop>
    <div class="mobile-detail-expert">
      <div class="detail-expert">
        <div class="detail-expert-left">
          <el-image
            class="exp-header"
            :src="expert.avatarUrl?'/old/public'+expert.avatarUrl:'http://expert.ckcest.cn/autoload/images/avatar.png'"
            fit="contain"
          >
            <div slot="placeholder" class="image-slot">
              <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
            </div>
            <div slot="error" class="image-slot">
              <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
            </div>
          </el-image>
          <el-button @click="dialogVisibleUpload = true" v-if="user && permissions">上传头像</el-button>
        </div>
        <div class="detail-expert-right">
          <div class="detail-expert-right-row">
            <div>
              <img class="img" src="static/img/icon/user.png" />
              <span style="margin-left: 5px;">{{expert.name}}</span>
            </div>

            <div>
              <!-- <img class="img" @click="share" src="static/img/icon/fx.png" /> -->
              <img class="img" @click="collect" src="static/img/mobile/coll.png" />
            </div>
          </div>
          <p>
            <img class="img" src="static/img/icon/university.png" />
            <span class="expert-right-org">{{expert.organization}}</span>
          </p>
          <p>
            <img class="img" src="static/img/icon/papers.png" />
            <span>{{expert.kId}}</span>
          </p>
          <p>
            <span>浏览量：{{count}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="mobile-detail-direction">
      <el-divider content-position="left">研究方向</el-divider>
      <div class="direction-echart">
        <wordcloud-Chart
          style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
          :WordCloudList="directionData"
          id="CNChart"
          height="100%"
          width="100%"
          tit
          @func="message"
          :isClick="true"
        />
      </div>
    </div>
    <div class="mobile-detail-intro">
      <el-divider content-position="left">个人简介</el-divider>
      <div class="detail-intro">
        <div :class="{introSatuts:!user}">{{expert.introduction}}</div>
        <el-button @click="$store.commit('dialogVisibleLogin', true)" v-if="!user">登录查看更多</el-button>
        <el-button v-if="user && permissions" @click="visibleIntro = true">编辑</el-button>
      </div>
    </div>
    <div class="mobile-detail-results">
      <el-divider content-position="left">研究成果</el-divider>
      <div class="detail-results">
        <div class="results-edit">
          <el-button size="mini" @click="visibleUrl = true" v-if="user">编辑</el-button>
        </div>
        <div class="results-options">
          <span>排序</span>
          <el-button
            size="small"
            :style="{background:order === 'asc'?'#6a8b89':'',color:order === 'asc'?'#fff':''}"
            @click="selectOrder('asc')"
          >按年份升序</el-button>
          <el-button
            size="small"
            :style="{background:order === 'desc'?'#6a8b89':'',color:order === 'desc'?'#fff':''}"
            @click="selectOrder('desc')"
          >按年份降序</el-button>
        </div>
        <div class="results-options">
          <span>年份</span>
          <el-button
            size="small"
            @click="selectYear('new')"
            :style="{background:year === 'new'?'#6a8b89':'',color:year === 'new'?'#fff':''}"
          >最近(20)</el-button>
          <el-button
            size="small"
            @click="selectYear('old')"
            :style="{background:year === 'old'?'#6a8b89':'',color:year === 'old'?'#fff':''}"
          >早期(20)</el-button>
          <el-button
            size="small"
            @click="selectYear('all')"
            :style="{background:year === 'all'?'#6a8b89':'',color:year === 'all'?'#fff':''}"
          >全部</el-button>
        </div>
        <div class="results-echart">
          <bar :chartData="barChart"></bar>
        </div>
        <div class="results-lists" id="results" v-loading="loading2">
          <div class="results-list" v-for="(item,index) in resultsData" :key="index">
            <div class="list-title" @click="clickUrl(item.url,item.title,item.doi)">{{item.title}}</div>
            <div v-if="item.resourceCode === 'O'">
              <span
                v-for="(item,index) in item.creatorAll.split(' ').slice(0,5)"
                :key="index"
              >{{item}} </span>
              <span>等共{{item.creatorAll.split(' ').length}}位专家参与</span>
            </div>
            <p v-else>{{item.creatorAll}}</p>
            <div class="list-footer">
              <span>{{item.journal ? '《' + item.journal+'》':''}}{{item.year?item.year+'年':''}} {{item.issue?item.issue+'期':''}}</span>
              <div>
                <el-tag>{{resultsCode[item.resourceCode] || '其他'}}</el-tag>
              </div>
            </div>
          </div>
        </div>
        <div class="loading" style="height:40px" v-if="loading1" v-loading="true"></div>
        <div class="loading" style="height:40px;display:flex" v-if="!more">
          <span style="margin:auto">已经最底部了</span>
        </div>
      </div>
    </div>

    <el-dialog title="上传文件" :visible.sync="dialogVisibleUpload" center>
      <div class="mobile-upload">
        <div class="mobile-upload-title">点击选择本机图片更新头像信息</div>
        <div class="mobile-upload-imgBox">
          <el-upload ref="upload" action="action" :http-request="upload" list-type="picture-card">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleUpload = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleUpload = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="visibleMsg" center>
      <div class="mobile-upload">
        <div class="mobile-upload-title">是否跳转到{{key}}页面</div>
        <div class="mobile-upload-imgBox"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleMsg = false">取 消</el-button>
        <el-button type="primary" @click="search">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改简介" :visible.sync="visibleIntro" center>
      <div class="mobile-upload-intro">
        <el-input type="textarea" :autosize="{ minRows: 2}" placeholder="请输入内容" v-model="intro"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleIntro = false">取 消</el-button>
        <el-button type="primary" @click="editIntro">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="发送链接" :visible.sync="visibleUrl" center>
      <div class="mobile-url">
        <p>您可以点击复制本链接，也可以将链接发送至您的邮箱，链接有效期3天，使用后失效</p>
        <el-button type="info" style="width:100%" @click="copyUrl">点击复制</el-button>
        <p>发送邮件</p>
        <el-input placeholder="请输入邮箱" v-model="Email"></el-input>
        <el-button type="info" style="width:100%;margin-top:20px" @click="sendEmail">发送邮件</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleUrl = false">取 消</el-button>
        <el-button type="primary" @click="editIntro">确 定</el-button>
      </span>
    </el-dialog>
  </div>

  <div style="height:100vh;width:100vw" v-else v-loading="true"></div>
</template>

<script>
import { getAuthorizationExp } from "@/api/center";
import WordcloudChart from "@/components/Charts/WordcloudChart";
import bar from "@/components/Charts/Bar";
import { getOrgArray, getQueryResources } from "@/api/detail";
import { getCount, sendEmail, getUrl } from "@/api/mobile";
import { upload, Update } from "@/api/claim";

let code = {
  O: "项目",
  A: "成果奖励",
  B: "图书",
  E: "EI",
  P: "专利",
  I: "Sci",
  J: "中文论文",
  C: "会议论文",
  D: "学位论文",
};
export default {
  name: "Detail",
  data() {
    return {
      kId: this.$route.query.kId, // Kid
      name: this.$route.query.name, // 姓名
      institute: this.$route.query.institute, // 机构
      count: null, // 浏览量
      loading: false, // 全局加载动画
      loading1: false, // 下一页加载动画
      loading2: false, // 成果加载加载动画
      expert: {}, // 专家信息
      barChart: {}, // 成果图表
      dialogVisibleUpload: false, // 上传图片弹窗
      visibleMsg: false, // 消息提示弹窗
      visibleIntro: false, //修改个人简介弹窗
      visibleUrl: false, // 发送链接弹窗
      from: 0, // 页数
      order: "desc", // 排序
      year: "new", // 年份
      more: true,
      directionData: [], // 研究方向数据
      key: "", // 关键词
      user: localStorage.getItem("mobileUser") || null, // 登录信息
      resultsData: [], // 成果数据
      resultsCode: code, // 成果类型判断
      url: null, // 链接
      doi: null, // doi
      msgTyep: 1, // 跳转类型
      intro: "", // 简介
      Email: "",
      permissions: false,
    };
  },
  methods: {
    // 上传图片按钮
    uploadBtn() {
      if (this.user) {
        this.dialogVisibleUpload = true;
      } else {
        this.$store.commit("dialogVisibleLogin", false);
      }
    },
    // 获取成果
    getData() {
      let data;
      let year = this.getYear();
      if (this.kId) {
        data = {
          from: 0,
          isClaimed: 1,
          kId: parseInt(this.kId),
          order: this.order,
          size: 10,
          sort: "year",
          year: year,
        };
      } else {
        let temp = [];
        temp[0] = this.expert;
        data = {
          from: 0,
          nameOrgArray: temp,
          order: this.order,
          size: 10,
          sort: "year",
          year: year,
        };
      }
      getQueryResources(data).then((res) => {
        this.loading2 = false;
        this.resultsData = res.obj.result;
        let temp = {
          year: [],
          count: [],
        };

        res.obj.stats1.year.forEach((it) => {
          temp.year.push(it.name);
          temp.count.push(it.count);
        });
        this.barChart = temp;
        this.minYear = res.obj.stats1.year[res.obj.stats1.year.length - 1].name;
      });
    },
    // 获取年份
    getYear() {
      if (this.year === "new") {
        var myDate = new Date();
        var year = myDate.getFullYear() - 1;
        let temp = [];
        for (let index = 0; index < 20; index++) {
          temp.push(year - index);
        }
        return temp;
      } else if (this.year === "old") {
        let temp = [];
        for (let index = 0; index < 20; index++) {
          temp.push(this.minYear + index);
        }
        return temp;
      } else {
        return "";
      }
    },
    // 点击标题
    clickUrl(url, title, doi) {
      this.url = null,
      this.doi = null
      if (url || doi) {
        this.visibleMsg = true;
        this.key = title + "原文链接";
        this.url = url;
        this.doi = doi;
        this.msgTyep = 2;
      }
    },
    // 点击图标内容
    message(val) {
      this.key = "检索" + val;
      this.msgTyep = 1;
      setTimeout(() => {
        this.visibleMsg = true;
      }, 100);
      // this.visibleMsg = true
    },
    // 跳转页面
    search() {
      if (this.msgTyep === 1) {
        this.$router.push({
          name: "mSearch",
          query: { key: this.key.split("检索")[1] },
        });
      } else {
        if (this.url) {
          let temp = decodeURIComponent(this.url);
          let goUrl = "";
          if (temp === this.url) {
            goUrl = this.url.split("amp;").join("");
          } else {
            goUrl = this.temp.split("skipurl=")[1];
          }
          if (this.url) {
            window.open(goUrl);
          }
        } else if (this.doi) {
          console.log(this.doi);
          let goUrl = "https://doi.org/" + this.doi;
          window.open(goUrl);
        }
      }
      this.visibleUrl = false
    },
    // 滚动事件
    getScroll(e) {
      this.$nextTick(() => {
        if (
          this.loading2 ||
          this.loading ||
          this.$route.path.toLowerCase() !== "/mobile/detail"
        ) {
          return;
        }
        if (!document.getElementById("view")) {
          return;
        }
        let dom = document.getElementById("view").offsetHeight;
        let hieght = document.documentElement.clientHeight;
        var top = Math.floor(
          document.body.scrollTop ||
            document.documentElement.scrollTop ||
            window.pageXOffset
        );
        if (top + hieght > dom) {
          if (this.loading1 || !this.more) {
            return;
          }

          this.from++;
          this.dronDown();
        }
      });
    },
    // 获取下一页
    dronDown() {
      this.loading1 = true;
      let data;
      let year = this.getYear();
      if (this.kId) {
        data = {
          from: (this.from - 1) * 10,
          isClaimed: 1,
          kId: parseInt(this.kId),
          order: this.order,
          size: 10,
          sort: "year",
          year: year,
        };
      } else {
        let temp = [];
        temp[0] = this.expert;
        data = {
          from: (this.from - 1) * 10,
          nameOrgArray: temp,
          order: this.order,
          size: 10,
          sort: "year",
          year: year,
        };
      }
      getQueryResources(data).then((res) => {
        this.loading1 = false;
        if (!res.obj.result.length) {
          this.more = false;
          return;
        }
        let temp = {
          year: [],
          count: [],
        };

        res.obj.stats1.year.forEach((it) => {
          temp.year.push(it.name);
          temp.count.push(it.count);
        });
        this.barChart = temp;
        this.resultsData = this.resultsData.concat(res.obj.result);
      });
    },
    // 选择排序
    selectOrder(val) {
      this.order = val;
      this.from = 0;
      this.loading2 = true;
      this.getData();
    },
    // 选择年份
    selectYear(val) {
      this.year = val;
      this.from = 0;
      this.loading2 = true;
      this.getData();
    },
    // 上传头像
    upload(file) {
      let formData = new FormData();
      const _file = file.file;
      formData.append("type", _file.type);
      formData.append("id", _file.uid);
      formData.append("name", _file.name);
      formData.append("lastModifiedDate", _file.lastModifiedDate);
      formData.append("size", _file.size);
      formData.append("file", _file);
      upload(formData).then((res) => {
        if (res.status === 1) {
          this.expert.avatarUrl =
            res.data.savepath.indexOf("newexpert") !== -1
              ? res.data.savepath.slice(21, res.data.savepath.length)
              : res.data.savepath;
          let data = {
            EmployeeId: 0,
            Expert: this.expert,
            UserId: JSON.parse(this.user).Id + "",
          };
          Update(data).then((res) => {
            this.$message({
              message: "修改成功",
              offset: "200",
            });
          });
          this.dialogVisibleUpload = false;
          this.$refs.upload.clearFiles();
        }
      });
    },
    // 修改简介
    editIntro() {
      let temp = this.expert;
      temp.introduction = this.intro;
      let data = {
        EmployeeId: 0,
        Expert: temp,
        UserId: JSON.parse(this.user).Id + "",
      };
      Update(data).then((res) => {
        this.$message({
          message: "修改成功",
          offset: "200",
        });
        this.expert.introduction = this.intro;
        this.visibleIntro = false;
      });
    },
    // 消息提醒
    msg(msg) {
      this.$message.closeAll();
      this.$message({
        message: msg,
        offset: 200,
      });
    },
    //复制链接
    copyUrl() {
      getUrl().then((res) => {
        if (res.code === 0) {
          var _input = document.createElement("input"); // 直接构建input
          _input.value = res.data; // 设置内容
          document.body.appendChild(_input); // 添加临时实例
          _input.select(); // 选择实例内容
          document.execCommand("Copy"); // 执行复制
          document.body.removeChild(_input); // 删除临时实例
          this.msg("复制成功");
        } else {
          this.msg("复制失败");
        }
      });
    },
    // 发送邮件
    sendEmail() {
      if (!this.Email) {
        this.msg("请输入邮箱");
        return;
      }
      let str = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!str.test(this.Email)) {
        this.msg("邮箱格式不正确");
        return;
      }
      sendEmail({ email: this.Email }).then((res) => {
        this.msg(res.msg);
      });
    },
    collect() {
      var url = window.location.href;
      var title = document.title;
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("360se") > -1) {
        this.msg("当前浏览器不支持，请手动收藏");
      } else if (ua.indexOf("msie 8") > -1) {
        window.external.AddToFavoritesBar(url, title); //IE8
      } else if (document.all) {
        //IE类浏览器
        try {
          window.external.addFavorite(url, title);
        } catch (e) {
          this.msg("当前浏览器不支持，请手动收藏");
        }
      } else if (window.sidebar) {
        //firfox等浏览器；
        window.sidebar.addPanel(title, url, "");
      } else {
        this.msg("当前浏览器不支持，请手动收藏");
      }
    },
  },
  mounted() {
    let data;
    this.loading = true;
    this.loading2 = true;
    if (this.kId) {
      data = {
        kId: this.kId,
      };
    } else {
      data = {
        name: this.name,
        institute: this.institute,
      };
    }
    window.addEventListener("scroll", this.getScroll, true);
    // 获取专家信息
    getOrgArray(data)
      .then((res) => {
        this.loading = false;
        this.expert = res[0];
        res[0].keyword.split(";").forEach((element) => {
          let temp = {
            name: element,
            count: 1,
          };
          this.directionData.push(temp);
        });
        this.intro = this.expert.introduction;
        this.Email = this.expert.email;
        this.getData();
      })
      .catch((err) => {
        console.log(err);
      });
    // 获取浏览量
    getCount({ url: window.location.href }).then((res) => {
      this.count = res.data.count;
    });
    // 获取名下专家
    if (this.user) {
      getAuthorizationExp({ PageIndex: 1, PageSize: 24 }).then((res) => {
        if (res.data.Data[0]) {
          if (this.expert.Kid === res.data.Data[0].ManagedExpert.KId) {
            this.permissions = true;
          }
        }
      });
    }
  },
  watch: {},
  components: {
    WordcloudChart,
    bar,
  },
};
</script>

<style lang="scss">
.mobile-detail {
  .mobile-detail-expert {
    margin: 20px 0;
    .detail-expert {
      padding: 20px 10px;
      display: flex;
      flex-direction: row;
      .detail-expert-left {
        text-align: center;
        img {
          max-width: 100%;
          margin-bottom: 20px;
        }
      }
      .detail-expert-right {
        padding-left: 20px;
        .detail-expert-right-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          align-items: center;
          div {
            display: flex;
            align-items: center;
          }
        }
        img {
          height: 30px;
        }
        p {
          width: 100%;
          margin-bottom: 10px;
          display: flex;
          align-items: center;

          span {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            margin-left: 5px;
          }
          .expert-right-org {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
          }
        }
      }
      @media screen and (max-width: 576px) {
        .detail-expert-left {
          width: 40%;
        }
        .detail-expert-right {
          img {
            height: 20px;
          }
          width: 60%;
        }
      }
      @media screen and (min-width: 576px) {
        .detail-expert-left {
          width: 30%;
        }
        .detail-expert-right {
          width: 70%;
          img {
            height: 30px;
          }
          p {
            margin-bottom: 20px;
          }
        }
      }
      @media screen and (min-width: 996px) {
        .detail-expert-left {
          width: 20%;
        }
        .detail-expert-right {
          width: 80%;
        }
      }
    }
  }
  .mobile-detail-direction {
    padding: 10px 0 0 0;
    margin: 10px 0;
    margin-top: 5%;
    .direction-echart {
      height: 300px;
      border: 1px solid #dcdfe6;
      border-top: none;
    }
  }
  .mobile-detail-intro {
    margin: 20px 0;
    .detail-intro {
      padding: 20px 10px;
      border: 1px solid #dcdfe6;
      border-top: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      .introSatuts {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        line-clamp: 5;
        -webkit-box-orient: vertical;
        white-space: normal;
      }
      .el-button {
        margin: 20px;
      }
    }
  }
  .mobile-detail-results {
    margin: 20px 0;
    .detail-results {
      padding: 20px 10px;
      border: 1px solid #dcdfe6;
      border-top: none;
      .results-edit {
        .el-button {
          float: right;
        }
      }
      .results-options {
        margin-top: 10px;
      }
      @media screen and (max-width: 370px) {
        .results-options {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 10px;
        }
      }
      @media screen and (min-width: 370px) {
        .results-options {
          .el-button {
            margin-left: 20px;
          }
        }
      }
      .results-echart {
        margin: 10px 0;
        height: 200px;
        width: 100%;
      }
      .results-lists {
        margin: 10px;
        .results-list {
          margin-top: 10px;
          padding-bottom: 20px;
          border-bottom: 1px dashed #e4e4e4;
          .list-title {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
          }
          p {
            word-wrap: break-word;
          }
          .list-footer {
            margin-top: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            div {
              display: flex;
              img {
                height: 20px;
              }
            }
          }
        }
        .results-more {
          margin: 20px 0 0 0;
          text-align: center;
        }
      }
    }
  }
  .mobile-upload {
    text-align: center;
  }
  .mobile-url {
    text-align: center;
    p {
      margin: 10px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mobile/Detail.vue